/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Invalidfiletitle2Inputs */

const en_common_invalidfiletitle2 = /** @type {(inputs: Common_Invalidfiletitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invalid File`)
};

/**
* | output |
* | --- |
* | "Invalid File" |
*
* @param {Common_Invalidfiletitle2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const common_invalidfiletitle2 = /** @type {((inputs?: Common_Invalidfiletitle2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Invalidfiletitle2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_common_invalidfiletitle2(inputs)
});
export { common_invalidfiletitle2 as "common_invalidFileTitle" }